<template>
  <Modal
    :id="'dtplugins-dbox_costs-files'"
    @cancelled="onCancel"
  >
    <template slot="header"> {{ itemName }} File </template>
    <template slot="body">
      <div class="body-container file-container">
        <div v-if="item" style="margin-bottom: 8px">
          <button
            class="dt-button v5 s8"
            @click="onChooseFileClick"
          >
            {{ file ? `${file.name}` : $t("Choose File") }}
          </button>
          <input
            type="file"
            name="cost_file"
            id="cost_file"
            style="visibility: hidden; display: none"
            @change="onFilePickerChange"
          />
        </div>
        <div class="ut-flex" v-if="item && item.file_id">
          <a :href="fileURL">
            <button class="dt-button v5 s8">
              {{ $t("download_file") }}
            </button>
          </a>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        class="dt-button v1 s6"
        :class="{ disabled: loadingFlag }"
        :disabled="loadingFlag"
        @click.stop="onOkClick"
      >
        {{
          this.file
            ? this.oldFileId
              ? $t("replace_file")
              : $t("add_new_document")
            : $t("ok")
        }}
      </button>
   
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { DBoxCostService } from "./dbox-costs.service";
import { MHTTPCL } from "../../services/http/http-client";

export default {
  components: {
    Modal,
    InputField,
    NTable,
  },
  props: ["itemName", "config", "item", "itemName"],
  mixins: [],
  async mounted() {},
  data() {
    return {
      file: null,
      loadingFlag: false,
    };
  },
  computed: {
    fileURL() {
      console.log(MHTTPCL); /*  */
      return `${MHTTPCL.getBaseUrl()}/files.pl?action=download_document&file_id=${
        this.item.file_id
      }`;
    },
    costSplitId() {
      return this.item.cost_split_id;
    },
    oldFileId() {
      return this.item && this.item.file_id;
    },
  },
  methods: {
    onOkClick: async function () {
      if (this.file) {
        const formData = new FormData();

        formData.append("file_name", this.file);
        formData.append("section", "common");
        formData.append("action", "mini_upload_file");
        formData.append("forWhich", "l_cost_splits");
        formData.append("related_item_id", this.costSplitId);
        formData.append(
          "old_file_id",
          this.oldFileId ? this.oldFileId : ""
        );
        this.loadingFlag = true;
        DBoxCostService.uploadFile(formData)
          .then((res) => {
            this.loadingFlag = false;
            this.$emit("uploaded", res.data);
          })
          .catch((e) => {
            this.$emit("cancelled", true);
          });
      } else {
        this.$emit("cancelled", true);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onFilePickerChange: function (event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.file = files[0];
        console.log({ "this.file": this.file });
      }
    },
    onChooseFileClick() {
      document.querySelector("#cost_file").click();
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dtplugins-dbox_costs-files {
  .file-container {
    min-height: 56px;
  }
}
</style>


